import { queryOptions } from '@tanstack/react-query'
import { api } from '@/api/client'
import { queryKeys } from '@/lib/query-keys'

export interface DashboardMonth {
  month: string
  transactions: number
  revenue: number
}

export interface DashboardTransactions {
  total: number
  months: DashboardMonth[]
}

export interface DashboardData {
  transactions: DashboardTransactions
}

export async function fetchDashboard(params?: {
  organisation_id?: number[]
}): Promise<DashboardData> {
  return api.get<DashboardData>('/dashboard', { params })
}

export function dashboardQueryOptions(params?: { organisation_id?: number[] }) {
  return queryOptions({
    queryKey: queryKeys.dashboard.summary(params),
    queryFn: async () => fetchDashboard(params),
  })
}
